// src/pages/Terms.jsx
import React from "react";
import "./LegalPages.css";

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Terms of Service</h1>
        <p>
          These Terms explain the rules for using NexterZone. By using the platform, you agree to follow them.
        </p>
      </div>

      <div className="legal-grid">
        <section className="legal-card">
          <h2>1. Platform purpose</h2>
          <p>
            NexterZone helps users trade items through a structured workflow designed for safety and accountability.
          </p>
        </section>

        <section className="legal-card">
          <h2>2. Prohibited activity</h2>
          <ul>
            <li>Stolen goods, counterfeit items, or illegally obtained property</li>
            <li>Weapons, illegal substances, or restricted goods</li>
            <li>Fraud, deception, or misrepresentation of item condition</li>
            <li>Attempting to move trades off-platform or exchange contact details</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>3. Listings and visibility</h2>
          <p>
            NexterZone may review, limit visibility, or remove listings that appear suspicious or do not meet policy.
            Trades in review are not intended for public browsing.
          </p>
        </section>

        <section className="legal-card">
          <h2>4. Verification and inspection</h2>
          <p>
            Some trades require additional verification evidence (photos/videos) and may be inspected during pickup,
            at a hub, or at delivery. If verification fails, the trade may be cancelled.
          </p>
        </section>

        <section className="legal-card">
          <h2>5. Enforcement</h2>
          <p>
            We may suspend accounts, cancel trades, restrict features, or cooperate with lawful requests when necessary
            to protect the community.
          </p>
        </section>
      </div>

      <div className="legal-footnote">
       These Terms summarise how NexterZone works and what is allowed on the platform. If we update these Terms, the latest version will always be available on this page.
      </div>
    </div>
  );
};

export default Terms;
